import numeral from "numeral";

export function formatCurrency(amountItem, formatShort = false) {
	const currencyFormatted = hasNumberValue(amountItem)
		? formatShort
			? numeral(amountItem).format("$0.0a")
			: numeral(amountItem).format("$0,0.00")
		: "";
	return currencyFormatted;
}

export function formatCurrencyNoDecimal(amountItem) {
	let currencyFormatted = hasNumberValue(amountItem)
		? numeral(amountItem).format("$0,0.00")
		: "";

	const currencyFormattedNew = currencyFormatted?.slice(0, -3);

	return currencyFormattedNew;
}

export function formatCurrencyAbbreviation(amountItem) {
	let currencyFormatted = hasNumberValue(amountItem)
		? numeral(amountItem).format("$0a")
		: "";
	return currencyFormatted;
}

export function formatErrorCurrency(amountItem, formatShort = false) {
	return hasNumberValue(amountItem)
		? formatShort
			? numeral(amountItem).format("$0[.]0a").replace("m", "")
			: numeral(amountItem).format("$0,0")
		: "";
}

export function formatPercentage(amountItem, precision = 2) {
	// Convert string to number
	let amountFloat = parseFloat(amountItem);
	let formattedAmt =
		(parseFloat(amountFloat * 100) / 100).toFixed(precision).toString() + "%";
	return formattedAmt;
}

export function hasNumberValue(input) {
	return typeof input === "number" || input?.length > 0;
}

export function toDecimal(input) {
	let amountFloat = parseFloat(input);
	let formattedAmt = amountFloat / 100;

	return formattedAmt;
}

export function currencyStringToNumber(input) {
	const retValue = numeral(input);
	return retValue._value;
}

export function valueWithinRange(amount, minAmount, maxAmount) {
	const checkValues = !amount || !minAmount || !maxAmount;
	if (checkValues) return false;

	return (
		Number(amount) >= Number(minAmount) && Number(amount) <= Number(maxAmount)
	);
}
